export default "__VITE_ASSET__4Rg0zObb__"